import { Outlet } from "react-router-dom";
import {
  BookOpenText,
  Bot,
  CalendarDays,
  ChartNoAxesCombined,
  FileChartColumn,
  HeartPulse,
  LayoutDashboard,
  Megaphone,
  MessageCircleMore,
  MessagesSquare,
  Sparkles,
  Stethoscope,
  UserRoundSearch,
  UsersRound,
  Cpu,
} from "lucide-react";
import { AppShell } from "./AppShell";
import { LogoutButton } from "./LogoutButton";
import { SidebarBrand, type NavGroup } from "./Sidebar";
import { useSession, isAdmin } from "@/lib/session";

export function AdminShell() {
  const { data: session } = useSession();
  const admin = isAdmin(session) ? session : null;

  // 14 links in one column was unscannable. Grouped by what the operator is
  // doing: handling patients now, managing the service, running the system.
  const groups: NavGroup[] = [
    {
      heading: "Operasional",
      items: [
        { to: "/admin", label: "Overview", icon: LayoutDashboard, end: true },
        { to: "/admin/health-monitoring", label: "Monitoring Kesehatan", icon: HeartPulse },
        { to: "/admin/livechat", label: "Live Chat", icon: MessageCircleMore },
        { to: "/admin/conversations", label: "Percakapan", icon: MessagesSquare },
        { to: "/admin/appointments", label: "Janji Temu", icon: CalendarDays },
        { to: "/admin/patients", label: "Pasien", icon: UserRoundSearch },
      ],
    },
    {
      heading: "Layanan",
      items: [
        { to: "/admin/doctors", label: "Dokter", icon: Stethoscope },
        { to: "/admin/knowledge", label: "Knowledge Base", icon: BookOpenText },
        { to: "/admin/broadcast", label: "Broadcast", icon: Megaphone },
        { to: "/admin/chatbot", label: "Buka Chatbot", icon: Bot },
      ],
    },
    {
      heading: "Analitik",
      items: [
        { to: "/admin/analytics", label: "Analitik", icon: ChartNoAxesCombined },
        { to: "/admin/intelligence", label: "Intelligence", icon: Sparkles },
        { to: "/admin/reports", label: "Laporan", icon: FileChartColumn },
      ],
    },
    {
      heading: "Sistem",
      items: [
        { to: "/admin/users", label: "Pengguna", icon: UsersRound },
        { to: "/admin/ai-models", label: "Model AI", icon: Cpu },
      ],
    },
  ];

  return (
    <AppShell
      groups={groups}
      brand={<SidebarBrand subtitle="Panel Admin" />}
      sidebarFooter={
        <div className="flex items-center gap-2.5 px-1 py-1">
          <span
            aria-hidden
            className="bg-void-700 text-void-100 grid size-8 shrink-0 place-items-center rounded-full text-xs font-bold"
          >
            {admin?.name?.charAt(0).toUpperCase() ?? "?"}
          </span>
          <span className="min-w-0 flex-1">
            <span className="text-void-100 block truncate text-sm font-semibold">
              {admin?.name ?? "Memuat…"}
            </span>
            <span className="text-void-500 block truncate text-2xs capitalize">
              {admin?.role}
            </span>
          </span>
          <LogoutButton as="admin" />
        </div>
      }
    >
      <Outlet />
    </AppShell>
  );
}
